export const MEMBERSHIP_MODAL_FIRST_SCREEN_FLAG =
	"membership-modal-first-screen" as const;

export type MembershipModalFirstScreenVariant = "control" | "test";

/**
 * Whether the PostHog flag value is the sharpened first-screen (L2+L3) variant.
 */
export const isMembershipModalFirstScreenTest = (
	flagValue: string | boolean | undefined,
): boolean => flagValue === "test";

/**
 * Resolve the modal first-screen variant from PostHog. Experiment ended —
 * inactive / non-`test` values resolve to control in every environment.
 */
export const resolveMembershipModalFirstScreenVariant = (
	flagValue: string | boolean | undefined,
): MembershipModalFirstScreenVariant =>
	isMembershipModalFirstScreenTest(flagValue) ? "test" : "control";
